import { createFileRoute } from '@tanstack/react-router';

import { MessagesLayout } from '../../features/messenger/ui/messages-layout.tsx';
import { requirePermissionRoute } from '../../lib/permissions.ts';

export const Route = createFileRoute('/_app/messages')({
  beforeLoad: requirePermissionRoute('messenger.use'),
  component: MessagesLayout,
});
